import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { PlaylistForm } from '../features/savedItems';

const EditPlaylist = () => {
  const {
    playlistId
  } = useParams();
  return /*#__PURE__*/_jsx(PlaylistForm, {
    action: "edit",
    playlistId: parseInt(playlistId, 10)
  });
};

export default EditPlaylist;